"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const campaignsActions = require("./campaigns");
const campaignExportActions = require("./campaignExport");
const campaignReportActions = require("./campaignReport");
const deviceListActions = require("./deviceList");
const deviceSchemaActions = require("./deviceSchema");
const editableCampaignActions = require("./editableCampaign");
const editableUIStateActions = require("./editableUIState");
const eventSchemaActions = require("./eventSchema");
const experienceActions = require("./experiences");
const notificationActions = require("./notification");
const segmentsActions = require("./segments");
const sendTestActions = require("./sendTest");
const testDevicesActions = require("./testDevices");
const userActions = require("./user");
const tagActions = require("./tags");
const overviewActions = require("./overview");
const reducers_1 = require("../reducers");
const getCampaignType_1 = require("../views/utils/getCampaignType");
exports.fetchUser = () => userActions.fetchUser();
exports.handleSendTestModalDisplay = (on) => overviewActions.handleSendTestModalDisplay(on);
exports.handleCloseOverviewModalDisplay = (history, path) => overviewActions.handleCloseOverviewModalDisplay(history, path);
exports.handleOpenOverviewModalDisplay = () => overviewActions.handleOpenOverviewModalDisplay();
exports.fetchTestDevices = (predicates, pageNumber, pageSize, condition) => testDevicesActions.fetchTestDevices(predicates, pageNumber, pageSize, condition);
exports.createCampaignExport = (keyword, status, triggerType) => campaignExportActions.createCampaignExport(keyword, status, triggerType);
exports.fetchCampaignExport = (id) => campaignExportActions.fetchCampaignExport(id);
exports.fetchDeviceUserInfo = () => deviceSchemaActions.fetchDeviceUserInfo();
exports.fetchEventSchemas = () => eventSchemaActions.fetchEventSchemas();
exports.fetchCampaigns = (searchChange, campaignStatus, keyword, first, after, triggerTypes) => campaignsActions.fetchCampaigns(searchChange, campaignStatus, keyword, first, after, triggerTypes);
exports.fetchCampaign = (campaignId) => campaignsActions.fetchCampaign(campaignId);
exports.createCampaign = (name, trigger) => campaignsActions.createCampaign(name, trigger);
exports.renameCampaign = (name, campaignId) => campaignsActions.renameCampaign(name, campaignId);
exports.duplicateCampaign = (name, campaignId) => campaignsActions.duplicateCampaign(name, campaignId);
exports.duplicateListViewCampaign = (name, campaignId) => campaignsActions.duplicateListViewCampaign(name, campaignId);
exports.archiveCampaign = (campaignId) => campaignsActions.archiveCampaign(campaignId);
exports.archiveListViewCampaign = (campaignId) => campaignsActions.archiveListViewCampaign(campaignId);
exports.archiveModalOpen = (display) => campaignsActions.archiveModalOpen(display);
exports.updateDeliverable = () => campaignsActions.updateDeliverable();
exports.publishCampaign = (campaignId) => campaignsActions.publishCampaign(campaignId);
exports.fetchReportConnection = (campaignId, after, before, first, last) => campaignsActions.fetchReportConnection(campaignId, after, before, first, last);
exports.updateTrigger = () => campaignsActions.updateTrigger();
exports.updateTags = (id, tags) => {
    return campaignsActions.updateTags(id, tags);
};
exports.getAllTags = (keyword) => {
    return tagActions.getTags(keyword);
};
exports.sendTest = (campaignId, deviceIds) => sendTestActions.sendTest(campaignId, deviceIds);
exports.updateSelectedTestDevices = (deviceIds) => testDevicesActions.updateSelectedTestDevices(deviceIds);
exports.openNewCampaignPopover = () => (dispatch) => {
    dispatch({ type: 'OPEN_NEW_CAMPAIGN_POPOVER' });
};
exports.closeNewCampaignPopover = () => (dispatch) => {
    dispatch({ type: 'CLOSE_NEW_CAMPAIGN_POPOVER' });
};
exports.openCampaignTypeSelector = () => (dispatch) => {
    dispatch({ type: 'OPEN_CAMPAIGN_TYPE_SELECTOR' });
};
exports.startClosingCampaignTypeSelector = () => (dispatch) => {
    dispatch({ type: 'START_CLOSING_CAMPAIGN_TYPE_SELECTOR' });
};
exports.closeCampaignTypeSelector = () => (dispatch) => {
    dispatch({ type: 'CLOSE_CAMPAIGN_TYPE_SELECTOR' });
};
exports.addPredicate = (predicate) => editableCampaignActions.addPredicate(predicate);
exports.removePredicate = (index) => editableCampaignActions.removePredicate(index);
exports.editPredicate = (index, predicate) => editableCampaignActions.editPredicate(index, predicate);
exports.updateEditableCampaign = (val) => editableCampaignActions.updateEditableCampaign(val);
exports.updateNotificationDeliverable = (updatedDeliverableFields) => editableCampaignActions.updateNotificationDeliverable(updatedDeliverableFields);
exports.updateAutomatedCampaignTrigger = (automatedCampaignFields) => editableCampaignActions.updateAutomatedCampaignTrigger(automatedCampaignFields);
exports.updateAutomatedEventTriggerEventName = (eventName) => editableCampaignActions.updateAutomatedEventTrigger({ eventName });
exports.updateAutomatedEventTriggerEventNamespace = (eventNamespace) => editableCampaignActions.updateAutomatedEventTrigger({ eventNamespace });
exports.updateEventAttributeOperator = (operator) => editableCampaignActions.updateEventAttributeOperator(operator);
exports.removeEventTriggerFilter = (filterName) => editableCampaignActions.removeEventTriggerFilter(filterName);
exports.updateEventAttributePredicates = (predicates) => editableCampaignActions.updateEventAttributePredicates(predicates);
exports.updateScheduledEventTriggerFilter = (dateTime) => editableCampaignActions.updateScheduledEventTriggerFilter(dateTime);
exports.updateTimeOfDayEventTriggerFilter = (timeOfDay) => editableCampaignActions.updateTimeOfDayEventTriggerFilter(timeOfDay);
exports.updateScheduledCampaignTrigger = (scheduledCampaignFields) => editableCampaignActions.updateScheduledCampaignTrigger(scheduledCampaignFields);
exports.createSegmentDeviceList = (deviceList) => (dispatch, getState) => {
    dispatch(editableCampaignActions.updateEditableCampaignTriggerSegment(Object.assign({ __typename: 'DeviceListSegment' }, deviceList)));
};
exports.updateSegmentDeviceList = (id, name, size, createdAt) => (dispatch, getState) => {
    const state = getState();
    const { trigger: { segment }, } = reducers_1.getEditableCampaign(state);
    dispatch(editableCampaignActions.updateEditableCampaignTriggerSegment(Object.assign(Object.assign({ __typename: 'DeviceListSegment' }, segment), { deviceList: {
            id,
            name,
            size,
            createdAt,
        } })));
    if (id) {
        dispatch(exports.fetchDeviceTotalSize());
    }
};
exports.updateSegmentDeviceListKeyPath = (keyPath) => (dispatch, getState) => {
    const state = getState();
    const { trigger: { segment }, } = reducers_1.getEditableCampaign(state);
    dispatch(editableCampaignActions.updateEditableCampaignTriggerSegment(Object.assign(Object.assign({ __typename: 'DeviceListSegment' }, segment), { keyPath })));
    if (segment.deviceList && segment.deviceList.id) {
        dispatch(exports.fetchDeviceTotalSize());
    }
};
exports.updateSegmentCondition = (condition) => (dispatch, getState) => {
    dispatch({ type: 'UPDATE_SEGMENT_CONDITION' });
    const state = getState();
    const { trigger } = reducers_1.getEditableCampaign(state);
    if (getCampaignType_1.isAutomatedCampaignTrigger(trigger) ||
        getCampaignType_1.isScheduledCampaignTrigger(trigger) ||
        getCampaignType_1.isAPICampaignTrigger(trigger)) {
        const segment = trigger.segment;
        let ids = [];
        if (segment && segment.__typename === 'CompoundSegment') {
            ids = segment.ids;
        }
        dispatch(editableCampaignActions.updateEditableCampaignTriggerSegment({
            __typename: 'CompoundSegment',
            ids,
            condition,
        }));
        dispatch(exports.fetchAudienceSizes());
    }
};
exports.updateDeviceSegmentBooleanOperator = (booleanOperator) => (dispatch, getState) => {
    const state = getState();
    const { predicate } = reducers_1.getEditableCampaignSegment(state);
    if (getCampaignType_1.isCompoundPredicate(predicate)) {
        dispatch(exports.updateDevicePredicateSegment(Object.assign(Object.assign({}, predicate), { booleanOperator: booleanOperator })));
    }
};
exports.updateCompoundDevicePredicateOperator = (booleanOperator, index) => (dispatch, getState) => {
    const state = getState();
    const { predicate } = reducers_1.getEditableCampaignSegment(state);
    if (getCampaignType_1.isCompoundPredicate(predicate)) {
        const predicateToUpdate = predicate.predicates[index];
        const newPredicate = Object.assign(Object.assign({}, predicateToUpdate), { booleanOperator });
        dispatch(exports.updateDevicePredicateSegment(Object.assign(Object.assign({}, predicate), { predicates: [
                ...predicate.predicates.slice(0, index),
                newPredicate,
                ...predicate.predicates.slice(index + 1),
            ] })));
    }
};
exports.updateDevicePredicateSegment = (predicate) => (dispatch) => {
    dispatch({ type: 'UPDATE_DEVICE_PREDICATE_SEGMENT' });
    dispatch(editableCampaignActions.updateEditableCampaignTriggerSegment({
        __typename: 'DevicePredicateSegment',
        predicate: predicate || { booleanOperator: 'OR', predicates: [] },
    }));
    dispatch(exports.fetchDeviceTotalSize());
};
exports.addDevicePredicateToSegment = (newPredicate) => (dispatch, getState) => {
    const state = getState();
    const { predicate } = reducers_1.getEditableCampaignSegment(state);
    if (getCampaignType_1.isComparisonPredicate(predicate)) {
        return dispatch(exports.updateDevicePredicateSegment({
            booleanOperator: 'OR',
            predicates: [predicate, newPredicate],
        }));
    }
    if (getCampaignType_1.isCompoundPredicate(predicate)) {
        return dispatch(exports.updateDevicePredicateSegment({
            booleanOperator: predicate.booleanOperator,
            predicates: [...predicate.predicates, newPredicate],
        }));
    }
};
exports.addDevicePredicateToCompoundPredicate = (newPredicate, parentIndex) => (dispatch, getState) => {
    const state = getState();
    const { predicate } = reducers_1.getEditableCampaignSegment(state);
    if (!getCampaignType_1.isCompoundPredicate(predicate)) {
        return;
    }
    const predicateToUpdate = predicate.predicates[parentIndex];
    if (getCampaignType_1.isComparisonPredicate(predicateToUpdate)) {
        return dispatch(exports.updateDevicePredicateSegment(Object.assign(Object.assign({}, predicate), { predicates: [
                ...predicate.predicates.slice(0, parentIndex),
                {
                    booleanOperator: 'AND',
                    predicates: [predicateToUpdate, newPredicate],
                },
                ...predicate.predicates.slice(parentIndex + 1),
            ] })));
    }
    if (getCampaignType_1.isCompoundPredicate(predicateToUpdate)) {
        return dispatch(exports.updateDevicePredicateSegment({
            booleanOperator: predicate.booleanOperator,
            predicates: [
                ...predicate.predicates.slice(0, parentIndex),
                {
                    booleanOperator: predicateToUpdate.booleanOperator,
                    predicates: [...predicateToUpdate.predicates, newPredicate],
                },
                ...predicate.predicates.slice(parentIndex + 1),
            ],
        }));
    }
};
const updateCompoundDevicePredicate = (predicate, newComparisonPredicate, index) => ({
    booleanOperator: predicate.booleanOperator,
    predicates: [
        ...predicate.predicates.slice(0, index),
        newComparisonPredicate,
        ...predicate.predicates.slice(index + 1),
    ],
});
exports.addDevicePredicateToComparisonPredicate = (newPredicate) => (dispatch, getState) => {
    const state = getState();
    const { predicate } = reducers_1.getEditableCampaignSegment(state);
    if (getCampaignType_1.isComparisonPredicate(predicate)) {
        return dispatch(exports.updateDevicePredicateSegment({
            booleanOperator: 'OR',
            predicates: [
                {
                    booleanOperator: 'AND',
                    predicates: [predicate, newPredicate],
                },
            ],
        }));
    }
};
exports.updateDevicePredicate = (newPredicate, predicateIndex, parentIndex) => (dispatch, getState) => {
    const state = getState();
    const { predicate } = reducers_1.getEditableCampaignSegment(state);
    if (getCampaignType_1.isComparisonPredicate(predicate)) {
        return dispatch(exports.updateDevicePredicateSegment(newPredicate));
    }
    if (getCampaignType_1.isCompoundPredicate(predicate)) {
        if (parentIndex === undefined) {
            const updatedPredicate = updateCompoundDevicePredicate(predicate, newPredicate, predicateIndex);
            return dispatch(exports.updateDevicePredicateSegment(updatedPredicate));
        }
        else {
            const parentPredicate = predicate.predicates[parentIndex];
            const updatedParent = updateCompoundDevicePredicate(parentPredicate, newPredicate, predicateIndex);
            const updatedPredicate = updateCompoundDevicePredicate(predicate, updatedParent, parentIndex);
            return dispatch(exports.updateDevicePredicateSegment(updatedPredicate));
        }
    }
};
exports.deleteDevicePredicate = (index, parentIndex) => (dispatch, getState) => {
    const state = getState();
    const { predicate } = reducers_1.getEditableCampaignSegment(state);
    if (getCampaignType_1.isComparisonPredicate(predicate)) {
        dispatch(exports.updateDevicePredicateSegment({
            booleanOperator: 'OR',
            predicates: [],
        }));
    }
    if (getCampaignType_1.isCompoundPredicate(predicate)) {
        const deleteEntireCompoundPredicate = () => dispatch(exports.updateDevicePredicateSegment({
            booleanOperator: predicate.booleanOperator,
            predicates: [...predicate.predicates.slice(0, index), ...predicate.predicates.slice(index + 1)],
        }));
        if (parentIndex === undefined) {
            return deleteEntireCompoundPredicate();
        }
        const parentPredicate = predicate.predicates[parentIndex];
        if (parentPredicate.predicates.length < 2) {
            return deleteEntireCompoundPredicate();
        }
        const newPredicate = Object.assign(Object.assign({}, predicate), { predicates: [
                ...predicate.predicates.slice(0, parentIndex),
                Object.assign(Object.assign({}, parentPredicate), { predicates: [
                        ...parentPredicate.predicates.slice(0, index),
                        ...parentPredicate.predicates.slice(index + 1),
                    ] }),
                ...predicate.predicates.slice(parentIndex + 1),
            ] });
        return dispatch(exports.updateDevicePredicateSegment(newPredicate));
    }
};
exports.addEditableSegmentIds = (newSegmentIds) => (dispatch, getState) => {
    const state = getState();
    const { trigger } = reducers_1.getEditableCampaign(state);
    if (getCampaignType_1.isAutomatedCampaignTrigger(trigger) ||
        getCampaignType_1.isScheduledCampaignTrigger(trigger) ||
        getCampaignType_1.isAPICampaignTrigger(trigger)) {
        dispatch({ type: 'ADD_EDITABLE_SEGMENT_IDS' });
        const compoundSegment = trigger.segment;
        const segmentIds = compoundSegment ? compoundSegment.ids : [];
        dispatch(editableCampaignActions.updateEditableCampaignTriggerSegment(Object.assign(Object.assign({}, compoundSegment), { ids: [...segmentIds, ...newSegmentIds] })));
        dispatch(exports.fetchAudienceSizes());
    }
};
exports.updateSegmentToAllDevices = () => (dispatch, getState) => {
    const state = getState();
    const { trigger } = reducers_1.getEditableCampaign(state);
    dispatch(exports.updateEditableCampaign({
        trigger: Object.assign(Object.assign({}, trigger), { segment: null }),
    }));
};
exports.removeEditableSegmentId = (segmentId) => (dispatch, getState) => {
    const state = getState();
    const { trigger } = reducers_1.getEditableCampaign(state);
    if (getCampaignType_1.isAutomatedCampaignTrigger(trigger) ||
        getCampaignType_1.isScheduledCampaignTrigger(trigger) ||
        getCampaignType_1.isAPICampaignTrigger(trigger)) {
        const compoundSegment = trigger.segment;
        const segmentIds = compoundSegment ? compoundSegment.ids : [];
        const newSegmentIDs = segmentIds.filter((id) => id !== segmentId);
        dispatch(editableCampaignActions.updateEditableCampaignTriggerSegment(Object.assign(Object.assign({}, trigger.segment), { ids: newSegmentIDs })));
        dispatch(exports.fetchAudienceSizes());
    }
};
exports.addEditableAPIField = (field) => (dispatch, getState) => {
    const state = getState();
    const { trigger } = reducers_1.getEditableCampaign(state);
    if (getCampaignType_1.isAPICampaignTrigger(trigger)) {
        const { fields } = trigger;
        dispatch(exports.updateEditableCampaign({
            trigger: Object.assign(Object.assign({}, trigger), { fields: fields.concat(field) }),
        }));
    }
};
exports.removeEditableAPIField = (index) => (dispatch, getState) => {
    const state = getState();
    const { trigger } = reducers_1.getEditableCampaign(state);
    if (getCampaignType_1.isAPICampaignTrigger(trigger)) {
        const { fields } = trigger;
        if (!fields[index]) {
            return;
        }
        dispatch(exports.updateEditableCampaign({
            trigger: Object.assign(Object.assign({}, trigger), { fields: fields.slice(0, index).concat(fields.slice(index + 1)) }),
        }));
    }
};
exports.updateFrequencyLimits = (limits) => editableCampaignActions.updateFrequencyLimits(limits);
exports.createEditableCampaign = (campaignId) => editableCampaignActions.createEditableCampaign(campaignId);
exports.unsetEditableCampaign = () => editableCampaignActions.unsetEditableCampaign();
exports.updateEditableUIState = (newUIStateGroup, newUIStateValue) => editableUIStateActions.updateEditableUIState(newUIStateGroup, newUIStateValue);
exports.fetchExperiences = () => experienceActions.fetchExperiences();
exports.setCurrentFormPage = (currentPage) => (dispatch) => {
    dispatch({ type: 'UPDATE_CURRENT_PAGE', currentPage: currentPage });
};
exports.updateLastVewPage = (lastViewPage) => (dispatch) => {
    dispatch({ type: 'UPDATE_LAST_VIEW_PAGE', lastViewPage });
};
exports.fetchCampaignReport = (id) => campaignReportActions.fetchNotificationReport(id);
exports.fetchDeviceLists = () => deviceListActions.fetchDeviceLists();
exports.uploadDeviceList = (file) => deviceListActions.uploadDeviceList(file);
exports.setHoverOption = (hover) => (dispatch) => {
    dispatch({ type: 'SET_HOVER_OPTION', hover });
};
exports.handleAlertOptionsModalDisplay = (deviceInfoSelected) => notificationActions.handleAlertOptionsModalDisplay(deviceInfoSelected);
exports.openTapBehaviorSelector = () => (dispatch) => {
    dispatch({ type: 'OPEN_TAP_BEHAVIOR_SELECTOR' });
};
exports.closeTapBehaviorSelector = () => (dispatch) => {
    dispatch({ type: 'CLOSING_TAP_BEHAVIOR_SELECTOR' });
    setTimeout(() => {
        dispatch({
            type: 'CLOSE_TAP_BEHAVIOR_SELECTOR',
        });
    }, 500);
};
exports.updateActivePhonePreview = (preview) => (dispatch) => dispatch({ type: 'UPDATE_ACTIVE_PHONE_PREVIEW', preview });
exports.startClosingPhonePreview = () => (dispatch) => dispatch({ type: 'START_CLOSING_PHONE_PREVIEW' });
exports.updateActivePopover = (field) => (dispatch) => {
    dispatch({
        type: 'UPDATE_ACTIVE_POPOVER',
        field,
    });
};
exports.openPopoverModalForm = () => (dispatch) => {
    dispatch({ type: 'OPEN_POPOVER_MODAL_FORM' });
};
exports.closePopoverModalForm = () => (dispatch) => {
    dispatch({ type: 'CLOSING_POPOVER_MODAL_FORM' });
    setTimeout(() => {
        dispatch({
            type: 'CLOSE_POPOVER_MODAL_FORM',
        });
    }, 500);
};
exports.updateReportGraphType = (reportGraphType) => (dispatch) => dispatch({
    type: 'UPDATE_REPORT_GRAPH_TYPE',
    reportGraphType,
});
exports.fetchSegments = () => segmentsActions.fetchSegments();
exports.fetchAudienceSizes = () => segmentsActions.fetchAudienceSizes();
exports.fetchDeviceTotalSize = () => segmentsActions.fetchDeviceTotalSize();
exports.openWizardModal = (stateType) => (dispatch) => {
    dispatch({ type: 'START_OPENING_WIZARD_MODAL', stateType });
    setTimeout(() => {
        dispatch({
            type: 'FINISH_OPENING_WIZARD_MODAL',
        });
    }, 500);
};
exports.closeWizardModal = () => (dispatch) => {
    dispatch({ type: 'START_CLOSING_WIZARD_MODAL' });
    setTimeout(() => {
        dispatch({
            type: 'FINISH_CLOSING_WIZARD_MODAL',
        });
    }, 350);
};
